import { createSlice } from "@reduxjs/toolkit";

// authSlice.js
const initialState = { adUser: null, loginUser: null, currUser: null };

export const appSlice = createSlice({
	name: "app",
	initialState,
	reducers: {
		setLoginUser: (state, action) => {
			state.loginUser = action.payload;
		},
		setActingAsUser: (state, action) => {
			state.currUser = action.payload;
		},
		setAdAuthUser: (state, action) => {
			console.log("setAdAuthUser", action);
			state.adUser = action.payload;
		},
		logout: (state) => {
			state.loginUser = null;
			state.currUser = null;
			state.adUser = null;
		},
	},
});

const { reducer } = appSlice;
export default reducer;
export const { setLoginUser, setActingAsUser, setAdAuthUser } = appSlice.actions;
